import React from 'react';

import { FormattedMessage } from 'react-intl';

import { UnitPendingLeadershipPosition } from '@appTypes/esb';
import { getPreferredName } from '@modules/shared/utils/preferredName';
import { DateView, S } from '@shared/components';

const rows = (item: UnitPendingLeadershipPosition) => {
  const { firstName, lastName, nickName } = item;

  const personPreferredName = getPreferredName({
    firstName,
    lastName,
    nickName,
  });
  const items = [
    {
      rowId: 'name',
      content: (
        <S size="4" bold colored title={personPreferredName}>
          {personPreferredName}
        </S>
      ),
    },
    {
      rowId: 'bsaMemberId',
      label: (
        <S size="4" bold>
          <FormattedMessage id="shared.memberId" />
        </S>
      ),
      content: <S size="4">{item.bsaMemberId}</S>,
    },
    {
      rowId: 'rank',
      label: (
        <S size="4" bold>
          <FormattedMessage id="shared.rank" />
        </S>
      ),
      content: <S size="4">{item.rank}</S>,
    },
    {
      rowId: 'position',
      label: (
        <S size="4" bold>
          <FormattedMessage id="shared.position" />
        </S>
      ),
      content: <S size="4">{item.position}</S>,
    },
    {
      rowId: 'startDate',
      label: (
        <S size="4" bold>
          <FormattedMessage id="shared.date.startDate" />
        </S>
      ),
      content: <DateView value={item.startDate} />,
    },
    {
      rowId: 'notes',
      label: (
        <S size="4" bold>
          <FormattedMessage id="shared.notesTitle" />
        </S>
      ),
      content: <DateView value={item.notes} />,
    },
  ];

  return items;
};

export default rows;
